



















import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import TopBar from '@/components/TopBar/TopBar.vue';

@Component({
	components: {
		TopBar,
	},
})
export default class Login extends Vue {
	@Action private login!: void;

	private mounted() {
		window.requestAnimationFrame(() => window.document.getElementById('login-button').focus());
	}
}
